<template lang='pug'>
//- 血壓血糖單筆瀏覽
div(:class='$style[`cc-popbox-chronic-blood`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(v-if='detail' :class='$style[`cc-chronic-blood-result`]')
    div(:class='$style[`cc-chronic-blood-vendor`]')
      div(:class='$style[`cc-chronic-blood-vendor-block`]')
        div(:class='$style[`cc-vendor-profile-info`]')
          .font-bold(:class='$style[`cc-vendor-profile-name`]') {{ detail.date }} 量測紀錄

    div(:class='$style[`cc-chronic-blood-result-main`]')
      //- 血糖記錄區塊
      section(v-if='detail.glucose && detail.glucose.length' :class='$style[`cc-blood-result-section`]')
        header.font-bold(:class='$style[`cc-blood-result-section-caption`]') 我的血糖
          span.font-medium (飯前空腹8小時 < 100 mg/dL，飯後2小時 < 140 mg/dL)
        ul(:class='$style[`cc-blood-result-section-ul`]')
          li(:class='[$style[`cc-blood-result-section-li`], $style[`cc-blood-result-section-topic`]]')
            div(:class='[$style[`cc-blood-result-section-result`], $style[`flex-1`]]')
              span.font-medium 上傳的圖片
            div(:class='[$style[`cc-blood-result-section-result`], $style[`flex-1`]]')
              span.font-medium 時間
            div(:class='[$style[`cc-blood-result-section-result`], $style[`flex-3`]]')
              span.font-medium 血糖值 / 量測時機
          li(
            v-for='items, index in detail.glucose.slice().reverse()'
            :class='$style[`cc-blood-result-section-li`]')
            div(:class='[$style[`cc-blood-result-section-result`], $style[`flex-1`]]')
              figure(:class='$style[`cc-blood-result-section-result-photo`]')
                img(:src='`${SERVER_STATIC_URL}media/${items.photo}`' width='100%')
            div(:class='[$style[`cc-blood-result-section-result`], $style[`flex-1`]]')
              span.font-bold {{ items.create_time ? formatTime(items.create_time) : '-' }}
            div(:class='[$style[`cc-blood-result-section-result`], $style[`flex-3`], $style[items.alert ? `cc-alert` : ``]]')
              span.font-bold(:class='$style[`cc-value-number`]') {{ items.value ? items.value : '-' }}
              span.font-bold mg/dL
              span.font-bold(:class='$style[`cc-meal-tag`]') {{ items.before_meal ? '飯前' : '飯後' }}

      //- 血壓記錄區塊
      section(v-if='detail.pressure && detail.pressure.length' :class='$style[`cc-blood-result-section`]')
        header.font-bold(:class='$style[`cc-blood-result-section-caption`]') 我的血壓
          span.font-medium (正常值為 120/80 mmHg，超過 140/90 即為高血壓，需持續追蹤及接受治療)
        //- 固定的基礎項目
        ul(:class='$style[`cc-blood-result-section-ul`]')
          li(:class='[$style[`cc-blood-result-section-li`], $style[`cc-blood-result-section-topic`]]')
            div(:class='[$style[`cc-blood-result-section-result`], $style[`flex-1`]]')
              span.font-medium 上傳的圖片
            div(:class='[$style[`cc-blood-result-section-result`], $style[`flex-1`]]')
              span.font-medium 時間
            div(:class='[$style[`cc-blood-result-section-result`], $style[`flex-3`]]')
              span.font-medium 收縮壓 / 舒張壓 / 每分脈搏
          li(
            v-for='items, index in detail.pressure.slice().reverse()'
            :class='$style[`cc-blood-result-section-li`]')
            div(:class='[$style[`cc-blood-result-section-result`], $style[`flex-1`]]')
              figure(:class='$style[`cc-blood-result-section-result-photo`]')
                img(:src='`${SERVER_STATIC_URL}media/${items.photo}`' width='100%')
            div(:class='[$style[`cc-blood-result-section-result`], $style[`flex-1`]]')
              span.font-bold {{ items.create_time ? formatTime(items.create_time) : '-' }}
            div(:class='[$style[`cc-blood-result-section-result`], $style[`flex-3`], $style[items.alert ? `cc-alert` : ``]]')
              span.font-bold(:class='$style[`cc-value-number`]') {{ items.systolic ? items.systolic : '-' }}
              span.font-bold /
              span.font-bold(:class='$style[`cc-value-number`]') {{ items.diastolic ? items.diastolic : '-' }}
              span.font-bold mmHg
              span.font-bold(:class='$style[`cc-meal-tag`]') {{ items.pulse ? items.pulse : '-' }}次

    div(:class='$style[`cc-chronic-blood-result-control`]')
      //- button(
      //-   title='刪除紀錄'
      //-   tabindex='0' aria-label='刪除紀錄'
      //-   :class='$style[`cc-chronic-blood-result-main-control-delete`]'
      //-   @click='deleteEproRecord')
      //-   IconTrash(:size='24' :color='`#d8374d`')
      //-   span 刪除紀錄

      button.btn-extra(
        title='關閉'
        tabindex='0' aria-label='關閉'
        :class='$style[`cc-chronic-blood-result-control-close`]'
        @click='handleClosePopBox')
        span 關閉

</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
// var emitter = require('tiny-emitter/instance');
import moment from 'moment-timezone';
import IconLoading from '../../icon/Loading';
import IconSearch from '../../icon/Search';
import IconTrash from '../../icon/Trash';

// import { debounce } from 'debounce';
// import GlobalEmitter from 'tiny-emitter/instance';

export default {
  components: {
    IconLoading,
    IconSearch,
    IconTrash,
  },

  props: {
    detail: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      date: '',
      glucose: [],
      pressure: [],
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopZoomStatus: 'global/POPZOOM_STATUS',
      changePopChronicBloodDetail: 'global/POPCHRONIC_BLOOD_DETAIL',
    }),

    formatTime(timeString) {
      if (!timeString) return '-';
      // 轉換為台灣時區
      const twTime = moment.utc(timeString).tz('Asia/Taipei');
      return twTime.format('HH:mm');
    },

    handleClickZoomPhoto(src) {
      this.changePopZoomStatus({
        active: true,
        src,
      });
    },

    // deleteEproRecord() {
    //   this.changePopDeleteEproStatus({
    //     active: true,
    //     id: this.recordId,
    //   });
    // },

    // popShowAnalysisDetail() {
    //   this.changePopAnalysisStatus({
    //     active: true,
    //     detail: {
    //       id: this.analysis.id,
    //       broadcast: this.analysis.broadcast,
    //       category: this.analysis.category,
    //       course: this.analysis.course,
    //       evaluate: this.analysis.evaluate,
    //       prediction: this.analysis.prediction,
    //       reminder: this.analysis.reminder,
    //       start_date: this.analysis.start_date,
    //       suggestion: this.analysis.suggestion,
    //       summary: JSON.parse(this.analysis.summary.replace(/'/g, '"')),
    //       vertex_source: this.analysis.vertex_source ? JSON.parse(this.analysis.vertex_source.replace(/'/g, '"')) : null,
    //     },
    //   });
    // },

    // transformDateMoment(date) {
    //   return moment(new Date(date)).format('YYYY.MM.DD');
    // },

    // joinArrayToString(arr) {
    //   return arr.join(',');
    // },

    handleClosePopBox() {
      this.changePopChronicBloodDetail({
        active: false,
        detail: null,
      });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      // subscribeVip: 'user/exportUserSubscribeVip',
      // loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popChronicBloodDetail.scss';
</style>
